var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileDesc(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39966 17C13.8179 17 17.3997 13.4183 17.3997 9C17.3997 4.58172 13.8179 1 9.39966 1C4.98138 1 1.39966 4.58172 1.39966 9C1.39966 13.4183 4.98138 17 9.39966 17Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39966 4.56444V4.55556M9.39966 13.4444L9.39966 7.22222M17.3997 9C17.3997 13.4183 13.8179 17 9.39966 17C4.98138 17 1.39966 13.4183 1.39966 9C1.39966 4.58172 4.98138 1 9.39966 1C13.8179 1 17.3997 4.58172 17.3997 9Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDesc);
export default __webpack_public_path__ + "static/media/mobileDesc.136c21d0a6b34f4f22968fc5a853db90.svg";
export { ForwardRef as ReactComponent };